import Html from './HtmlHelper.js';

class ResponseStatus {
    static SUCCESS = 0;
    static NOT_FOUND = 1;
    static VALIDATION_FAILED = 2;
}

class ConfigurationService {
    _settings;
    _httpClient;
    _modal;
    _dossierNotFoundMessage;
    _validationFailedMessage;

    constructor(settings, httpClient, modal) {
        this._settings = settings;
        this._httpClient = httpClient;
        this._modal = modal;
        this._dossierNotFoundMessage = Html.getById('dossier-not-found');
        this._validationFailedMessage = Html.getById('validation-failed');
    }

    async getConfigurationByShareKey(shareKey) {
        const url = `/getconfigurationasync?shareKey=${shareKey.trim()}&languageId=${this._settings.languageId}&mediatype=json`;

        try {
            const data = await this._httpClient.get(url);

            if (data === null || data.Status === ResponseStatus.NOT_FOUND) {
                this._dossierNotFoundMessage.classList.add('is-active');
            } else if (data.Status === ResponseStatus.VALIDATION_FAILED) {
                this._validationFailedMessage.classList.add('is-active');
            } else if (data.DossierId === '00000000-0000-0000-0000-000000000000') {
                this._dossierNotFoundMessage.classList.add('is-active');
            } else {
                document.dispatchEvent(new CustomEvent('get-configuration-data-success', { detail: { data }}));
            }
        } catch (error) {
            console.error(error.message);
            if (error.userFriendlyExceptionMessage) {
                this._modal.setModal(true, error.userFriendlyExceptionMessage);
            }
        }
    }

    _hideErrorMessages() {
        this._dossierNotFoundMessage.classList.remove('is-active');
        this._validationFailedMessage.classList.remove('is-active');
    }
}

export default ConfigurationService;